<template>
  <div>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card outlined tile flat color="#191919">
          <v-layout justify-center wrap pt-5>
            <v-flex xs12 text-center pb-2>
              <span class="servicesHead">Services</span>
            </v-flex>
            <v-flex xs12 sm12 md3 lg3 xl3 text-center>
              <span class="servicesSub"
                >Our service aim to reach to the Micro to medium sized
                enterprises in their ever increasing need of Data
                Management.</span
              >
            </v-flex>
          </v-layout>
          <v-layout justify-center wrap pt-10 pb-5>
            <v-flex xs12 sm12 md8 lg8 xl8>
              <v-tabs
                v-model="tab"
                hide-slider
                background-color="#191919"
                color="#008FDB"
                grow
                class="notactive"
              >
                <v-tab v-for="(item, i) in items" :key="i">
                  <span :class="tab == i ? 'imactive' : 'notactive'">
                    {{ item }}
                  </span>
                </v-tab>
                <v-tab-item>
                  <v-card outlined flat tile color="#191919">
                    <v-layout justify-center wrap py-6>
                      <v-flex
                        xs12
                        sm4
                        md4
                        lg4
                        xl4
                        v-for="(list, index) in itemArray1"
                        :key="index"
                      >
                        <v-img
                          class="align-end"
                          :height="
                            $vuetify.breakpoint.name == 'xl' ? '500px' : '400px'
                          "
                          :width="
                            $vuetify.breakpoint.name == 'xl'
                              ? '500px'
                              : $vuetify.breakpoint.name == 'lg'
                              ? '500px'
                              : '400px'
                          "
                          :src="list.image"
                        >
                          <v-layout
                            wrap
                            justify-start
                            class="bgClass"
                            style="cursor: pointer"
                          >
                            <v-flex
                              xs12
                              sm12
                              md12
                              pa-4
                              align-self-end
                              text-left
                            >
                              <v-layout wrap>
                                <v-flex lg6>
                                  <span class="text">{{ list.name }}</span>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex lg1 pt-8>
                                  <span>></span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-img>
                      </v-flex>
                      <!-- <v-flex xs4>
                        <v-img
                          class="align-end"
                          :height="
                            $vuetify.breakpoint.name == 'xl' ? '500px' : '400px'
                          "
                          :width="
                            $vuetify.breakpoint.name == 'xl' ? '500px' : '400px'
                          "
                          src="./../../assets/images/Group 9165/Group 9165.png"
                          ><v-layout
                            wrap
                            justify-start
                            class="bgClass"
                            style="cursor: pointer"
                          >
                            <v-flex
                              xs12
                              sm12
                              md12
                              pa-4
                              align-self-end
                              text-left
                            >
                              <v-layout wrap>
                                <v-flex lg6>
                                  <span class="text">
                                    Business Transcription</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout></v-img
                        >
                      </v-flex> -->
                      <v-flex xs12 sm4 md4>
                        <v-layout
                          justify-center
                          wrap
                          v-for="(data, index1) in itemArray2"
                          :key="index1"
                        >
                          <v-img
                            class="align-end"
                            :height="
                              $vuetify.breakpoint.name == 'xl'
                                ? '250px'
                                : '200px'
                            "
                            :width="
                              $vuetify.breakpoint.name == 'xl'
                                ? '500px'
                                : $vuetify.breakpoint.name == 'lg'
                                ? '500px'
                                : '400px'
                            "
                            :src="data.image"
                            ><v-layout
                              wrap
                              justify-start
                              class="bgClass"
                              style="cursor: pointer"
                            >
                              <v-flex
                                xs12
                                sm12
                                md12
                                pa-4
                                align-self-end
                                text-left
                              >
                                <v-layout wrap>
                                  <v-flex lg6>
                                    <span class="text">{{ data.name }}</span>
                                  </v-flex>
                                  <v-spacer></v-spacer>
                                  <v-flex lg1 pt-xs-3 pt-8>
                                    <span>></span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout></v-img
                          >
                        </v-layout>
                        <!-- <v-img
                          class="align-end"
                          :height="
                            $vuetify.breakpoint.name == 'xl' ? '250px' : '200px'
                          "
                          :width="
                            $vuetify.breakpoint.name == 'xl' ? '500px' : '400px'
                          "
                          src="./../../assets/images/Mask Group 8/Mask Group 8.png"
                          ><v-layout
                            wrap
                            justify-start
                            class="bgClass"
                            style="cursor: pointer"
                          >
                            <v-flex xs12 sm12 md12 pa-4 align-self-end text-left
                              ><v-layout wrap>
                                <v-flex lg8>
                                  <span class="text"> Document</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout></v-img
                        > -->
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card outlined flat tile color="#DEDEDE">
          <v-layout justify-start wrap pt-7 pb-10>
            <v-flex xs12 sm10 md10 text-center>
              <v-layout justify-end wrap>
                <v-flex xs11 sm4 md4 lg4 xl4 text-start>
                  <span style="color: #a2a2a2; font-family: ibmplexsanssemibold"
                    >What we enable:</span
                  >
                  <br />
                  <span
                    style="
                      color: #000000;
                      font-family: ibmplexsanssemibold;
                      font-size: 30px;
                    "
                    >Grow your Business</span
                  >
                </v-flex>
                <v-flex xs11 sm5 md5 lg5 xl5>
                  <span style="color: #404040; font-family: ibmplexsanssemibold"
                    >We aim to tap the huge gap currently in this sector
                    especially in recognising the Data management and Analytics
                    along with the Document Solutions and Analytics for the
                    Business Decisions.</span
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card color="#F2F2F2">
          <v-layout justify-center wrap pb-16 pt-5>
            <v-flex xs12 sm12 md8 lg8 xl8>
              <v-tabs
                v-model="tab1"
                hide-slider
                height="100px"
                color="#00000"
                background-color="#F2F2F2"
                grow
                class="notactive1"
              >
                <v-tab v-for="(list, index) in items1" :key="index">
                  <span :class="tab1 == index ? 'imactive1' : 'notactive1'">
                    {{ list }}
                  </span>
                </v-tab>
                <v-tab-item>
                  <v-layout justify-center wrap>
                    <v-flex xs12>
                      <v-card outlined color="white">
                        <v-layout justify-center wrap>
                          <v-flex xs12 sm6 md6 py-16 pt-16>
                            <v-layout justify-start wrap>
                              <v-flex xs12 sm12 md6 lg6 pa-2>
                                <span class="servicesubHead"
                                  >Transform data into insight.</span
                                >
                                <br />
                                <br />
                                <span class="servicesubText"
                                  >DMAAC envisages modern enterprises and its
                                  vision. We project the futuristic vision of
                                  Smart Enterprising. Our focus is on Data
                                  Science and possibilities of Machine Learning
                                  and Block Chain.</span
                                ><v-layout justify-start wrap>
                                  <v-flex xs12 pt-16>
                                    <v-btn
                                      outlined
                                      style="
                                        text-transform: none;
                                        font-family: ibmplexsansregular;
                                      "
                                      color="#0038FF"
                                      >Know More ></v-btn
                                    >
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm12 md5 lg5 pt-16>
                            <v-img
                              src="./../../assets/images/System.svg"
                            ></v-img>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab1: null,
      tab: null,
      items: [" Data Handling", "  Digital Analytics", "System Implementation"],
      items1: [
        " Data Handling",
        "  Digital Analytics",
        "System Implementation",
      ],

      itemArray1: [
        {
          image: require("./../../assets/images/Group 8321/Group 8321.png"),
          name: "Medical Transcriptions",
        },
        {
          image: require("./../../assets/images/Group 9165/Group 9165.png"),
          name: "Business Transcription",
        },
      ],
      itemArray2: [
        {
          image: require("./../../assets/images/Mask Group 7/Mask Group 7.png"),
          name: "Product Literature",
        },
        {
          image: require("./../../assets/images/Mask Group 8/Mask Group 8.png"),
          name: "Document",
        },
      ],
    };
  },
};
</script>
<style>
.imactive {
  color: #ffffff !important;
  font-family: ibmplexsanssemibold;
  font-size: 20px !important;
  text-transform: none !important;
  padding-bottom: 6px;
  border-bottom: 4px solid #0038ff;
}
.notactive {
  color: #bfbfbf !important;
  font-family: ibmplexsanssemibold;
  font-size: 12px !important;
}
.imactive1 {
  color: black !important;
  font-family: ibmplexsanssemibold;
  font-size: 20px !important;
  text-transform: none !important;
  padding-bottom: 6px;
  border-bottom: 4px solid #0038ff;
}
.notactive1 {
  color: #8b8b8b !important;
  font-family: ibmplexsanssemibold;
  font-size: 12px !important;
}
.text {
  color: white;
  font-family: ibmplexsanssemibold;
  font-size: 18px;
}
.bgClass :hover {
  background-color: #008fdb;
}
</style>
